import React, { useMemo, useRef } from "react";
import { useFormContext, useFormState } from "react-hook-form";

import { useTranslation } from "react-i18next";

import { SvgPrimes } from "@routes/IconeSvg";

import ArrowLitle from "@assets/image/icones/calendarParametre/Vector.svg";

import LitleDisclosure from "@components/disclosure/LitleDisclosure";

import PrimeDropdown from "./PrimeDropdown";

export default function ContainerPrimeDropdown({
  classParentList,
  showAction,
  validateDropdown,
  disabled,
  additionalIcon = false,
  lists,
  indexParent,
  index,
  revalidate,
  // isSubmitted,
  setIdPrimesToDelete,
  idPrimesToDelete,
  customWidthFade = "",
  onPointing
}) {
  const { t } = useTranslation("prime.prime");
  const { control } = useFormContext();
  const { errors } = useFormState({ control });
  const autoCloseRef = useRef(null);
  const definitiveLists = useMemo(() => onPointing ? lists?.filter((_prime) => !Boolean(_prime?.isAutomatic)) : lists || [], [lists, onPointing]);
  const hasInvalidError = (errorNode) => {
    if (!errorNode) return false;
    if (Array.isArray(errorNode)) {
      return errorNode.some((item) => hasInvalidError(item));
    }
    if (typeof errorNode === "object") {
      if (errorNode.type || errorNode.types) return true;
      return Object.values(errorNode).some((value) => hasInvalidError(value));
    }
    return false;
  };
  const isPrimeInvalid = hasInvalidError(
    errors?.BlocDays?.[indexParent]?.WorkingHours?.[index]?.primes
  );
  if (!definitiveLists?.length) return "";
  return (
    <div
      //ref={wrapperRef}
      className={`${classParentList} arh-flex arh-w-full arh-flex-col`}
    >
      <label
        className={`arh-mb-1 arh-flex arh-w-full arh-font-poppins arh-text-xs arh-font-medium ${
          isPrimeInvalid ? "arh-text-invalidColorTextInput" : "arh-text-black"
        }`}
      >
        {t("Prime(s)")}
      </label>
      <LitleDisclosure
        classParent="arh-rounded arh-border arh-border-solid arh-border-[#ECECEC] arh-h-[2.75rem]"
        LitleTitle={true}
        titleIcon={SvgPrimes()}
        title={t("Ajouter une prime")}
        // defaultOpen={isEdit}
        defaultOpen={false}
        spaceTitle={true}
        classSpaceTitle="arh-ml-[0.848rem]"
        customArrow={true}
        customArrowShape={ArrowLitle}
        customPadding="arh-pt-[0.6rem] arh-pb-[0.2rem]"
        // autoCloseRef={autoCloseRef}
        innerRef={autoCloseRef}
        autoClose={true}
      >
        {/* {fadeIn ? ( */}
        <div
          className="arh-h-full arh-w-full"
        // onClick={toggleOptionList}
        >
          <div
            className={`arh-absolute arh-z-20 arh-mt-2 !arh-w-[28rem] arh-rounded arh-bg-white arh-p-4 arh-shadow-lg ${!showAction ? "_employee" : ""
              } ${customWidthFade} `}
          //onClick={(e) => e.stopPropagation()}
          >
            <PrimeDropdown
              lists={definitiveLists}
              indexParent={indexParent}
              index={index}
              revalidate={revalidate}
              // isSubmitted={isSubmitted}
              setIdPrimesToDelete={setIdPrimesToDelete}
              idPrimesToDelete={idPrimesToDelete}
              disabled={disabled}
              onPointing={onPointing}
            />
          </div>
        </div>
        {/* ) : null} */}
      </LitleDisclosure>
    </div>
  );
}
